import isGHMC, { formatDateTimeWithoutSec, formattedDate, formattedDateForBE, formattedDateTypeTwo, getCurrentDate, getCurrentDateTime, getFirstDateOfMonth } from "../../../../Common/helper/helpar";
import Modal from "react-bootstrap/Modal";
import { MonthWiseAttendanceFilters } from "../../Attendance/MonthWiseAttendanceSummary/MonthWiseAttendanceFilters";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    TablePagination,
    Paper,
} from "@mui/material";

import { useEffect, useState } from "react";
import Loader from "../../../../Common/Loader/loader";
import { InnerTippingFeeExport } from "./InnerTippingFeeExport";
import { useNavigate } from "react-router-dom";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";
import TableSkeleton from "../../../AllotedMaster/TableSkeleton";

const TippingFeeCalculationInnerReport = () => {
    const { loading, fetchTippingFeeCalculationInnerZoneReport, tippingFeeInnerZoneReportData } = TippingFeeCalculationStore()
    const navigate = useNavigate()
    const storedFilters = localStorage.getItem("tippingFeeInnerFilterDate");
    const currentDate = getCurrentDateTime();
    const parsedFilters = JSON.parse(storedFilters);

    const convertToYYYYMMDD = (dateString) => {
  if (!dateString) return "";

  const [day, month, year] = dateString.split("-");

  return `${year}-${month}-${day}`;
};
    
    useEffect(() => {
          console.log(parsedFilters, "parsedFilters")
        if (storedFilters) {
            const values={
                FromDate:convertToYYYYMMDD(parsedFilters),
                ToDate:convertToYYYYMMDD(parsedFilters)
            }
            console.log("values",values)
            fetchTippingFeeCalculationInnerZoneReport(values)
        }
    }, []);
  

   const formatTwo = (val) => Number(val || 0).toFixed(2);

    const totalGHMCTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Trips) || 0), 0);
    const totalHMSWTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Trips) || 0), 0);
    const totalTrips = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.total_Trips) || 0), 0);
    const totalGHMCTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_NetWeight) || 0), 0);
    const totalHMSWTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_NetWeight) || 0), 0);
    const totalTonnage = tippingFeeInnerZoneReportData.reduce((sum, item) => sum + (parseFloat(item.total_Tonnage) || 0), 0);


    const isProd = isGHMC();
    const headerStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        color: "#fff",
        backgroundColor: isProd ? "#0d5da5" : "#EC1117",
    };
    const cellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
    };

    return (
        <>
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        <div className="d-flex justify-content-end align-items-end">
                            <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                                Back
                            </button>
                            <InnerTippingFeeExport fromDate={parsedFilters} toDate={parsedFilters}/>
                        </div>

                        <div className="page-header text-start">
                            <div className="card">
                                <div className="card-body">
                                    <div className="top-header d-flex justify-content-center align-items-center">
                                        <span>Zone-Wise Tipping Fee Report as on ({parsedFilters}) at ({formatDateTimeWithoutSec(currentDate)}) </span>
                                    </div>
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            width: "100%",
                                            border: "1px solid #ccc",
                                            maxHeight: 700,
                                        }}
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead
                                                className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                                                style={{ position: "sticky", top: 0 }}
                                            >
                                                <TableRow>
                                                    <TableCell rowSpan={2} sx={headerStyles}>S.No</TableCell>
                                                    <TableCell rowSpan={2} sx={headerStyles}>Corporation</TableCell>
                                                    <TableCell rowSpan={2} sx={headerStyles}>Zone</TableCell>
                                            
                                                    <TableCell colSpan={3} sx={headerStyles} style={{ textAlign: "center" }}>Trips</TableCell>
                                                    <TableCell colSpan={3} sx={headerStyles} style={{ textAlign: "center" }}>Tonnage</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={headerStyles}>GHMC</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW</TableCell>
                                                    <TableCell sx={headerStyles}>Total</TableCell>

                                                    <TableCell sx={headerStyles}>GHMC</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW</TableCell>
                                                    <TableCell sx={headerStyles}>Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                           <TableBody>
  {loading ? (
    <TableRow>
      <TableCell colSpan={9} align="center">
        <TableSkeleton />
      </TableCell>
    </TableRow>
  ) : tippingFeeInnerZoneReportData?.length > 0 ? (
    <>
      {tippingFeeInnerZoneReportData.map((item, index) => (
        <TableRow
          key={index}
          sx={{
            backgroundColor: isProd
              ? index % 2 === 0
                ? "#8fc9ff"
                : "#aed8ff"
              : index % 2 === 0
              ? "#F8CCCD"
              : "#ffeded",
          }}
        >
          <TableCell sx={cellStyles}>{index + 1}</TableCell>
          <TableCell sx={cellStyles}>{item.corporationName || "N/A"}</TableCell>
          <TableCell sx={cellStyles}>{item.zoneName || "N/A"}</TableCell>

          {/* Trips */}
          <TableCell sx={cellStyles}>{item.ghmC_Trips || 0}</TableCell>
          <TableCell sx={cellStyles}>{item.himsW_Trips || 0}</TableCell>
          <TableCell sx={cellStyles}>{item.total_Trips || 0}</TableCell>

          {/* Tonnage */}
          <TableCell sx={cellStyles}>{item.ghmC_NetWeight || 0}</TableCell>
          <TableCell sx={cellStyles}>{item.himsW_NetWeight || 0}</TableCell>
          <TableCell sx={cellStyles}>{item.total_Tonnage || 0}</TableCell>
        </TableRow>
      ))}

      {/* Total Row */}
      <TableRow>
        <TableCell sx={cellStyles}></TableCell>
        <TableCell sx={cellStyles}></TableCell>
        <TableCell sx={cellStyles}><strong>Total</strong></TableCell>

        <TableCell sx={cellStyles}><strong>{totalGHMCTrips}</strong></TableCell>
        <TableCell sx={cellStyles}><strong>{totalHMSWTrips}</strong></TableCell>
        <TableCell sx={cellStyles}><strong>{totalTrips}</strong></TableCell>

        <TableCell sx={cellStyles}><strong>{formatTwo(totalGHMCTonnage)}</strong></TableCell>
        <TableCell sx={cellStyles}><strong>{formatTwo(totalHMSWTonnage)}</strong></TableCell>
        <TableCell sx={cellStyles}><strong>{formatTwo(totalTonnage)}</strong></TableCell>
      </TableRow>
    </>
  ) : (
    <TableRow>
      <TableCell colSpan={9} align="center">
        <strong>No Data Available</strong>
      </TableCell>
    </TableRow>
  )}
</TableBody>
                                        </Table>
                                    </TableContainer>


                                    {/* </Paper> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    );
};

export default TippingFeeCalculationInnerReport;
